






















































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  LinkedAccountApi
} from "@/shared/types";
import { Validator } from "vee-validate";
import Button from "@/shared/components/ui/Button.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import Input from "@/shared/components/ui/Input.vue";
import { useBankAccountStore } from "@/employee/store/bankAccount";

@Component({
  components: {
    Button,
    RadioButton,
    Input,
  }
})
export default class NewLinkedBankAccountForm extends Vue {
  $validator: Validator;

  @Prop()
  existingAccount: undefined | LinkedAccountApi;

  accountName = "";
  accountNumberBackingField = "";
  accountNumberPlaceholder = "";
  routingNumber = "";
  accountType = "checking";

  bankAccountStore = useBankAccountStore();

  get addOrSaveText () {
    return this.existingAccount ? "Save" : "Add Linked Account";
  }

  get validateAccountNumber () {
    return {
      // for existing accounts, the account number is empty
      // unless user makes a change
      bankaccount: !!this.accountNumber,
      required: !this.existingAccount
    };
  }

  get accountNumber () {
    return this.accountNumberBackingField;
  }

  set accountNumber (s: string) {
    this.accountNumberBackingField = s.trim();
  }

  mounted () {
    if (!this.existingAccount) {
      return;
    }

    this.accountName = this.existingAccount.bankAccountName;
    this.accountNumber = "";
    this.accountNumberPlaceholder = this.existingAccount.bankAccountNumber;
    this.routingNumber = this.existingAccount.bankRoutingNumber;
    this.accountType = this.existingAccount.linkedBankAccountType;
  }

  onCancelClick () {
    this.$emit("exitAddAccountClicked", true);
  }

  setLinkedAccountType (value: string) {
    this.accountType = value;
  }

  onAddClick () {
    this.$validator.validateAll().then(isValid => {
      if (!isValid) {
        return;
      }

      const linkedAccount = this.existingAccount ? this.updateExisting() : this.createLinkedAccount();
      this.bankAccountStore.putLinkedAccount(linkedAccount)
          .then(_ => this.$emit("exitAddAccountClicked", true));
    });
  }

  onDeleteClick () {
    this.bankAccountStore.deleteLinkedAccount(this.existingAccount);
  }

  updateExisting (): LinkedAccountApi {
    // yikes, this is a prop mutation, logged to BEND-9480
    this.existingAccount.bankAccountName = this.accountName;
    this.existingAccount.bankRoutingNumber = this.routingNumber;
    this.existingAccount.linkedBankAccountType = this.accountType;
    if (this.accountNumber) {
      this.existingAccount.bankAccountNumber = this.accountNumber;
    }

    return this.existingAccount;
  }

  createLinkedAccount (): LinkedAccountApi {
    return {
      linkedBankAccountId: 0,
      bankAccountNumber: this.accountNumber,
      bankRoutingNumber: this.routingNumber,
      verificationStatus: "none",
      bankAccountName: this.accountName,
      linkedBankAccountType: this.accountType
    };
  }
}
